export default "__VITE_ASSET__af51a1ec__"